// extracted by mini-css-extract-plugin
export default {"mainWrapper":"G3145f5"};